<template>
  <div class="insights-optin-frame">
    <div class="insights-optin-frame__content">
      <InsightOptinMainBanner />
      <div class="como-tratar-os-dados">
        <div class="icone">
          <MaterialIcon icon="bar_chart" />
        </div>
        <div class="title">Como tratamos seus dados</div>
        <div class="description">Aceite os termos para prosseguir</div>
      </div>
      <div class="box-items">
        <div class="item" v-for="item in items" :key="item.icon">
          <div class="icone">
            <MaterialIcon :icon="item.icon" />
          </div>
          <div class="text" v-html="sanitizeHtml(item.text)" />
        </div>
      </div>
      <div class="termos-condicoes">
        <div class="checkbox">
          <F360Checkbox v-model="aceitarTermos" />
        </div>
        <div class="text">
          Li e concordo com os
          <a @click="handleTermos" class="link">Termos de Uso</a> e Política de
          Privacidade
        </div>
      </div>
      <div class="button-ativar">
        <F360Button
          filled
          style="width: 115px"
          @click="isConfiguracaoDialogOpen = true"
          :disabled="!aceitarTermos"
          >Ativar Agente</F360Button
        >
      </div>
    </div>
  </div>

  <InsightConfiguracaoDialog
    :gerarRelatorio="true"
    v-model="isConfiguracaoDialogOpen"
    :tipo="ETipoConfiguracao.ATIVAR"
  />
</template>

<script setup lang="ts">
import InsightOptinMainBanner from "./components/InsightOptinMainBanner.vue";
import MaterialIcon from "@/ui/components/Icons/MaterialIcon/MaterialIcon.vue";
import F360Checkbox from "@/ui/components/Checkboxs/Checkbox/F360Checkbox.vue";
import { ref } from "vue";
import F360Button from "@/ui/components/Buttons/Button/F360Button.vue";
import InsightConfiguracaoDialog from "../../../../widgets/configuracao/InsightConfiguracaoDialog.vue";
import { ETipoConfiguracao } from "../../../../widgets/configuracao/types";
import { sanitizeHtml } from "@/core/common/sanitizeHtml";

//const loading = ref(false);
const aceitarTermos = ref(false);
const isConfiguracaoDialogOpen = ref(false);

const items = [
  {
    icon: "verified_user",
    text: "Os dados coletados geram os insights e ajudam a melhorar o produto, sempre de <b>forma anônima</b>."
  },
  {
    icon: "check_circle",
    text: "<b>A precisão dos insights</b> depende da <b>qualidade</b> das informações registradas no sistema."
  },
  {
    icon: "search_insights",
    text: "<b>Os insights são gerados por Inteligência Artificial e têm caráter orientativo</b>, não substituindo análises profissionais."
  }
];

const handleTermos = () => {
  window.open("https://f360.com.br/politica-privacidade/", "_blank");
};
</script>

<style scoped lang="scss">
.insights-optin-frame {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  margin-top: 10px;
  border-radius: 8px;
  background-color: #fff;
  padding: 16px;

  &__content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;

    .como-tratar-os-dados {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 8px;
      margin: 24px 0;

      .icone {
        width: 24px;
        height: 24px;
        background-color: _map.get($map: $azulPrincipal, $key: 700);
        border-radius: 5px;
        padding: 4px;
        color: _map.get($map: $neutro, $key: 0);
      }

      .title {
        font-size: 16px;
        font-weight: 700;
        color: _map.get($map: $neutro, $key: 700);
      }

      .description {
        font-size: 12px;
        font-weight: 400;
        color: _map.get($map: $neutro, $key: 700);
      }
    }

    .box-items {
      display: flex;
      flex-direction: row;
      align-items: stretch;
      gap: 16px;
      margin-bottom: 24px;

      .item {
        display: flex;
        flex: 1;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 8px;
        min-width: 0;
        border: 1px solid _map.get($map: $neutro, $key: 100);
        border-radius: 5px;
        padding: 12px;

        .icone {
          width: 24px;
          border-radius: 5px;
          padding: 0 0px 4px 4px;
          color: _map.get($map: $azulPrincipal, $key: 700);
        }

        .text {
          font-family: "Plus Jakarta Sans", sans-serif;
          font-weight: 400;
          font-size: 16px;
          color: _map.get($map: $neutro, $key: 700);
          padding: 0 5px;
        }
      }
    }

    .termos-condicoes {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin-bottom: 24px;

      .text {
        font-size: 14px;
        font-weight: 400;
        color: _map.get($map: $neutro, $key: 700);

        a {
          text-decoration: underline;
          color: _map.get($map: $azulPrincipal, $key: 700);
          cursor: pointer;
        }
      }
    }

    .button-ativar {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin-bottom: 24px;
    }
  }
}

@media (max-width: 768px) {
  .insights-optin-frame {
    padding: 16px;
    &__content {
      .como-tratar-os-dados {
        .icone {
          width: 20px;
          height: 20px;
        }
      }
    }

    .box-items {
      flex-direction: column;
      gap: 8px;
      height: auto;
      margin-top: 16px;
    }

    .termos-condicoes {
      flex-direction: column;
      gap: 8px;
      margin-top: 16px;
    }
    .button-ativar {
      width: 100%;
      margin-top: 16px;
    }

    .termos-condicoes {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin-top: 16px;

      .text {
        font-size: 12px;
        font-weight: 400;
        color: _map.get($map: $neutro, $key: 700);
      }
    }
  }
}
</style>
